


























	import Vue from 'vue';
    import ModUserListComp from "../components/moderation/ModUserListComp.vue";
    import ModRaidListComp from "../components/moderation/ModRaidListComp.vue";
	import { UserRole } from "../../../models/Enums";

    export default Vue.extend({
        name: "ModerationPage",
        components: {ModUserListComp},
        data: () => ({
            moderationCompNames: ['Spieler-Verwaltung', 'Raid-Verwaltung'],
            moderationComps: [ModUserListComp, ModRaidListComp],
        }),
        computed: {
            showContainer: function(): boolean {
                return this.$vStore.getters.loggedInUser.role > UserRole.Raider;
            }
        }
    })
